import { render, staticRenderFns } from "./newProgramEdition.vue?vue&type=template&id=82201990"
import script from "./newProgramEdition.vue?vue&type=script&lang=js"
export * from "./newProgramEdition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports